import { render, staticRenderFns } from "./upload2.vue?vue&type=template&id=7cc9cfac&scoped=true&"
import script from "./upload2.vue?vue&type=script&lang=js&"
export * from "./upload2.vue?vue&type=script&lang=js&"
import style0 from "./upload2.vue?vue&type=style&index=0&id=7cc9cfac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc9cfac",
  null
  
)

export default component.exports